import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/dataset', [
    {
      path: '',
      name: 'dataset',
      redirect: { name: 'dataset-list' },
    },
    {
      path: '/list',
      name: 'dataset-list',
      component: () => import('@/views/dataset/DataSetList.vue'),
    },
    {
      path: '/create',
      name: 'dataset-create',
      component: () => import('@/views/dataset/DataSetCreate.vue'),
    },
    {
      path: '/details/:id(\\d+)?',
      name: 'dataset-edit',
      component: () => import('@/views/dataset/DataSetEdit.vue'),
    },
  ]);
};
